export default __webpack_public_path__ + "static/media/Policy_With_Respect_To_Obligations_Of_Directors_and_Senior_Management_2.7f36b250.pdf";